import { render, staticRenderFns } from "./VendasInfo.vue?vue&type=template&id=9c1e4026&"
import script from "./VendasInfo.vue?vue&type=script&lang=js&"
export * from "./VendasInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports